import GlobalDispatcher from '../../events/GlobalDispatcher';
import BaseGameModel from "../../base/model/BaseGameModel";
import EntryPoint from "../../EntryPoint";

export default class SlotGameModel extends BaseGameModel {
    constructor() {
        super();
        this._lastResponseData = null;
        this._currency = '';
        this._balance = 100;
        this._lines = 3;
        this._bet = 1;
        this._reels = [[1, 1, 1], [1, 1, 1], [1, 1, 1]];
        this._winnings = null;
        this._betPossible = [1, 2, 3, 4, 5];
        this._linesPossible = [3];
        this._freeSpins = {
            left: 0,
            total: 0,
            totalWin: 0
        };

        this._isAutoPlay = false;
    }

    init() {
        this.addListeners();
        EntryPoint.GameModel = this;
        GlobalDispatcher.dispatch('model:init');
    }

    addListeners() {
        GlobalDispatcher.add('ui:changeBet', this.onChangeBetPressed, this);
        GlobalDispatcher.add('ui:changeLines', this.onChangeLinesPressed, this);
        GlobalDispatcher.add('ui:changeAutoPlay', this.onChangeAutoPlayPressed, this);
    }

    checkStartSpin() {
        if (this.balance >= this.totalBet) {
            GlobalDispatcher.dispatch('model:startSpin');
            this.balance -= this.totalBet;
            return true;
        } else {
            //console.log('noMoney');
            GlobalDispatcher.dispatch('model:noMoney');
            if (this.isAutoPlay) {
                this.isAutoPlay = false;
            }
            return false;
        }
    }

    onChangeBetPressed(data) {
        this.changeBet(data.params);
    }

    onChangeLinesPressed(data) {
        this.changeLines(data.params);
    }

    onChangeAutoPlayPressed(data) {
        this.changeAutoPlay(data.params);
    }

    setNewData(data) {
        this._lastResponseData = data;
        this.setNewBalance(data)

        if (data.currency) {
            this._currency = data.currency;
        }

        if (data.params) {
            this._betPossible = data.params.betPossible || this._betPossible;
            this._linesPossible = data.params.linesPossible || this._linesPossible;
        }
        if (data.current) {
            this._bet = data.current.bet || this._bet;
            this._lines = data.current.lines || this._lines;
        }
        if (data.spin) {
            this._reels = data.spin.reels || this._reels;
            this._winnings = data.spin.winnings || null;
        }
        //if (data.freeSpins) {
            this._freeSpins = data.freeSpins || null;
        //}

        GlobalDispatcher.dispatch('model:getServerData', data.action);
    }

    setNewBalance(data) {
        if (data.balance || data.balance === 0) {
            this._balance = data.balance;
        }
    }

    changeBet(data) {
        let index = this._betPossible.indexOf(this.bet);
        let indexDimension = 0;
        switch (data) {
            case 'increase':
                indexDimension = 1;
                break;
            case 'decrease':
                indexDimension = -1;
                break;
            default:
                index = data;
        }
        let newIndex = index + indexDimension;
        if (newIndex === this._betPossible.length) {
            newIndex = 0;
        }
        if (newIndex < 0) {
            newIndex = this._betPossible.length - 1;
        }
        this.bet = this._betPossible[newIndex];

        EntryPoint.PostMessages.onBetUpdate(this.bet)
    }

    changeLines(data) {
        let index = this._linesPossible.indexOf(this.lines);
        let indexDimension = 0;
        switch (data) {
            case 'increase':
                indexDimension = 1;
                break;
            case 'decrease':
                indexDimension = -1;
                break;
            default:
                index = data;
        }
        let newIndex = index + indexDimension;
        if (newIndex === this._linesPossible.length) {
            newIndex = 0;
        }
        if (newIndex < 0) {
            newIndex = this._linesPossible.length - 1;
        }
        this.lines = this._linesPossible[newIndex];
    }

    changeAutoPlay(data) {
        if (data === undefined) {
            this.isAutoPlay = !this.isAutoPlay;
        } else {
            this.isAutoPlay = data;
        }
    }

    get balance() {
        return this._balance;
    }

    set balance(value) {
        this._balance = value;
        GlobalDispatcher.dispatch('model:balanceChanged', this.balance);
    }

    get bet() {
        return this._bet;
    }

    set bet(value) {
        this._bet = value;
        GlobalDispatcher.dispatch('model:betChanged', this.bet);
    }

    get lines() {
        return this._lines;
    }

    set lines(value) {
        this._lines = value;
        GlobalDispatcher.dispatch('model:linesChanged', this.lines);
    }

    get reels() {
        return this._reels;
    }

    set reels(value) {
        this._reels = value;
    }

    get winnings() {
        return this._winnings;
    }

    set winnings(value) {
        this._winnings = value;
    }

    get totalBet() {
        return this.bet * this.lines;
    }

    get totalWin() {
        if (this._winnings) {
            return this.winnings.totalWin;
        }
        return 0;
    }

    get betPossible() {
        return this._betPossible;
    }

    get linesPossible() {
        return this._linesPossible;
    }

    get freeSpins() {
        return this._freeSpins;
    }

    get currency() {
        return this._currency;
    }

    get isFreeSpins() {
        return this.freeSpins && this.freeSpins.total > 0 && this.freeSpins.left !== 0
    }

    get isAutoPlay() {
        return this._isAutoPlay;
    }

    set isAutoPlay(value) {
        this._isAutoPlay = value;
        GlobalDispatcher.dispatch('model:autoPlayChanged', this.isAutoPlay);
    }
}
